import {
    AfterViewInit,
    Component,
    EventEmitter,
    ElementRef, ViewChild,
    Input, OnChanges,
    OnDestroy,
    Output, SimpleChanges
} from '@angular/core';
import { PaymentMethodModel } from '../../../../../shared/models/payment-method.model';
import { InstallmentModel } from '../../../../../shared/models/installment.model';
import { PaymentStepsService } from '../../../../services/payment-steps.service';
import { CardModel } from '../../../../../shared/models/card.model';
import { AddressModel } from '../../../../../shared/models/address.model';
import { PaymentGatewayModel } from '../../../../../shared/models/payment-gateway.model';
import { PaymentService } from '../../../../services/payment.service';
import { ResumeUpdaterService } from '../../../../../cart/services/cart-resume-updater.service';
import { CurrencyPipe, DecimalPipe } from '@angular/common';
import { MobileScrollToService } from '../../../../../shared/services/mobile-scroll-to.service';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Subscription } from 'rxjs/Subscription';
import { CommonHttpService } from '../../../../../shared/services/http.service';
import { ActivatedRoute } from '@angular/router';

@AutoUnsubscribe()
@Component({
    'selector': 'payment-payment-option-card-option',
    'templateUrl': './payment.payment.option.card.option.component.html'
})
export class PaymentPaymentOptionCardOptionComponent implements AfterViewInit, OnDestroy, OnChanges {
    public loading = false;
    public loadingCards = false;
    public loadingConfigurations = true;
    public flagNewCard = false;
    public cards: Array<CardModel> = [];
    public installmentModelValue: number = 1;
    public amountModelValue: number = 1;
    public installments: Array<InstallmentModel> = [];
    public mustReloadInstallments = false;
    protected currencyPipe = new CurrencyPipe('pt-BR');
    protected percentPipe = new DecimalPipe('pt-BR');
    private cardFormFilled = false;
    public installmentsOrder = 'ASC';
    @Input() index: number;
    @Input() cardIndex: number;
    @Input() cardsCount: Array<number>;
    @Input() paymentMethod: PaymentMethodModel;
    @Input() deliverable: boolean;
    @Input() amountDifference: number;
    @Input() total: number;
    @Output() filled: EventEmitter<number> = new EventEmitter();
    @Output() unfilled: EventEmitter<number> = new EventEmitter();
    @Output() submitted: EventEmitter<AddressModel> = new EventEmitter();
    @Output() findingZipCode: EventEmitter<string> = new EventEmitter();
    @Output() foundZipCode: EventEmitter<string> = new EventEmitter();
    @Output() notFoundZipCode: EventEmitter<string> = new EventEmitter();
    @Output() amountChanged: EventEmitter<number> = new EventEmitter();

    @ViewChild('installmentSelect') installmentSelect: ElementRef;

    paymentStepsServiceLoadCards: Subscription;
    paymentStepsServiceLoadCardsAfterViewInit: Subscription;
    paymentStepsServiceLoadInstallments: Subscription;
    resumeUpdaterServiceUpdated: Subscription;
    loadInstallmentsAfterViewInit: Subscription;

    constructor(
        protected paymentStepsService: PaymentStepsService,
        protected resumeUpdaterService: ResumeUpdaterService,
        protected paymentService: PaymentService,
        protected http: CommonHttpService,
        private mobileScrollToService: MobileScrollToService,
        protected activatedRoute: ActivatedRoute
    ) {
        this.paymentStepsService.loadingPaymentGatewayConfigurations$
            .subscribe(() => {
                this.loadingConfigurations = true;
            });
        this.paymentStepsService.loadedPaymentGatewayConfigurations$
            .subscribe((paymentGateway: PaymentGatewayModel) => {
                this.loadingConfigurations = false;
                if (paymentGateway.tokenization_allowed) {
                    this.paymentStepsServiceLoadCards = this.paymentStepsService
                        .loadCards(this.paymentMethod)
                        .subscribe();
                }
            });
        this.paymentStepsService.loadingCards$
            .subscribe(() => {
                this.loadingCards = true;
            });
        this.paymentStepsService.loadedCards$
            .subscribe((cards: Array<CardModel>) => {
                this.cards = cards;
                this.loadingCards = false;
            });

        this.activatedRoute.data.map((data) => {
                return data.storeConfigurations;
            }).subscribe((data) => {
                if (
                    data['checkout_installments_order'] !== undefined
                    && data['checkout_installments_order'] !== null
                ) {
                    this.installmentsOrder = data['checkout_installments_order'];
                }
            });
    }

    ngAfterViewInit() {
        this.loadingConfigurations = (this.cardIndex === 1);
        if (this.cardIndex > 1 &&
            this.paymentMethod.payment_gateway_tenant.tokenization_allowed
        ) {
            this.paymentStepsServiceLoadCardsAfterViewInit = this.paymentStepsService
                .loadCards(this.paymentMethod)
                .subscribe();
        }

        this.resumeUpdaterServiceUpdated = this.resumeUpdaterService.updated$
            .subscribe(() => {
                this.paymentStepsServiceLoadInstallments = this.paymentStepsService
                    .loadInstallments(this.paymentMethod)
                    .subscribe((installments: Array<InstallmentModel>) => {
                        this.installments = this.normalizeInstallments(installments);

                        if(this.installmentsOrder == 'DESC'){
                            this.installments = this.installments.sort((prev, next) => next.number - prev.number);
                            const highestInstallment = this.installments[0];
                            this.installmentModelValue = highestInstallment.number;
                            this.onChangeInstallments(highestInstallment.number);
                        }else{
                            const lowestInstallment = this.installments.sort((prev, next) => prev.number - next.number)[0];
                            this.installmentModelValue = lowestInstallment.number;
                            this.onChangeInstallments(lowestInstallment.number);
                        }
                    });
            });

        this.resumeUpdaterService.refresh();

        this.loadInstallmentsAfterViewInit = this.paymentStepsService
            .loadInstallments(this.paymentMethod)
            .subscribe((installments: Array<InstallmentModel>) => {
                this.installments = this.normalizeInstallments(installments);
                this.installmentModelValue = this.installments[0].number;
                this.onChangeInstallments(this.installments[0].number);
            });

        this.resumeUpdaterService.refresh();

        this.mobileScrollToService.scrollTo('#scroll-to-card-payment-options');
    }
    ngOnDestroy() {
        // Overrided by AutoUnsubscribe
    }
    ngOnChanges(changes: SimpleChanges) {
        this.triggerFilledIfFilled();

        let mustRefreshInstallments = changes.hasOwnProperty('amountDifference')
            && changes['amountDifference'].firstChange === false;
        if (mustRefreshInstallments) {
            this.mustReloadInstallments = true;
        }
    }

    /**
     * submitted event listener.
     **/
    public onSubmitted(): void {
        this.submitted.emit();
    }
    /**
     * findingZipCode event listener.
     **/
    public onFindingZipCode(zipCode) {
        this.findingZipCode.emit(zipCode);
    }
    /**
     * foundZipCode event listener.
     **/
    public onFoundZipCode(zipCode) {
        this.foundZipCode.emit(zipCode);
    }
    /**
     * notFoundZipCode event listener.
     **/
    public onNotFoundZipCode(zipCode) {
        this.notFoundZipCode.emit(zipCode);
    }
    /**
     * Verify if all cards was filled and then trigger filled event.
     **/
    public onFilled(cardIndex) {
        this.cardFormFilled = true;
        this.fillInstallmentsOnCardObject();
        this.fillAmountOnCardObject();
        this.filled.emit(this.cardIndex);
    }
    /**
     * Verify if all cards was filled and then trigger filled event.
     **/
    public onUnfilled(cardIndex) {
        this.cardFormFilled = false;
        this.unfilled.emit(this.cardIndex);
    }
    /**
     * Return true if card form is allowed to appears.
     **/
    public cardFormAllowed(): boolean {
        return !this.isLoading() && (
            !this.paymentMethod.payment_gateway_tenant.tokenization_allowed ||
            this.cards.length === 0 ||
            this.flagNewCard
        );
    }
    /**
     * Return true if tokenized cards list is allowed to appears.
     **/
    public cardListAllowed(): boolean {
        return !this.isLoading() && (
            this.paymentMethod.payment_gateway_tenant.tokenization_allowed &&
            this.cards.length > 0 &&
            !this.flagNewCard
        );
    }
    /**
     * Return true if something is loading.
     **/
    public isLoading(): boolean {
        return (this.loading || this.loadingCards || this.loadingConfigurations);
    }
    public onBlurAmountInput($event) {
        let amount = $event.target.value.replace(/\./g, '').replace("R$", "").replace(",",".").trim();
        this.onChangeAmountInput(amount);
        this.mustReloadInstallments = true;
    }
    public onChangeAmountInput(amount) {
        if (this.cardsCount.length === 1) {
            return;
        }

        this.amountModelValue = this.sanitizeAmountValue(amount);
        this.amountChanged.emit(this.amountModelValue);
        this.triggerFilledIfFilled();
    }
    public onChangeInstallments(installment) {
        if (this.cardsCount.length === 1) {
            this.registerInstallmentsForSingleCard(installment, () => {
                this.registerInstallmentsForSingleCard(installment);
                this.triggerFilledIfFilled();
            });

            this.triggerFilledIfFilled();
            return;
        }

        this.registerInstallmentsForMultipleCards(installment, () => {
            this.registerInstallmentsForMultipleCards(installment);
            this.triggerFilledIfFilled();
        });

        this.triggerFilledIfFilled();
    }
    /**
     * Build installment translation object returning parameters for
     * translation string.
     **/
    public buildInstallmentTranslation(installment: InstallmentModel): any {
        const params = {
            'installmentNumber': installment.number,
            'formattedInstallmentAmount': this.toCurrency(installment.amount)
        };
        if (installment.interest > 0) {
            params['formattedInstallmentInterest'] = this.toDecimal(installment.interest);
            params['formattedInstallmentInterestAmount'] = this.toCurrency(installment.interest_amount);
        }

        if (installment.discount_amount_installment > 0) {
            params['formattedInstallmentDiscount'] = this.toDecimal(installment.discount_amount_installment);
            params['formattedInstallmentDiscountAmount'] = this.toCurrency(installment.amount);
            params['porcentInstallmentDiscountAmount'] = this.percentPipe.transform(installment.percentage_discount, '1.0-2');
        }

        return params;
    }
    /**
     * Check if installment has interest value to build installment text.
     **/
    public hasInterest(installment: InstallmentModel) {
        return installment.interest > 0;
    }
    public hasDiscount(installment: InstallmentModel) {
        return (installment.discount_amount_installment != undefined && installment.discount_amount_installment != null && installment.discount_amount_installment > 0);
    }
    public onMultipleCardsInstallmentsReloaded() {
        this.mustReloadInstallments = false;
    }

    /**
     * Format to BRL currency using CurrencyPipe.
     **/
    private toCurrency(value: number) {
        return this.currencyPipe.transform(
            value,
            'BRL',
            true,
            '1.2-2'
        );
    }
    /**
     * Format to BRL percent using PercentPipe.
     **/
    private toDecimal(value: number) {
        return this.percentPipe.transform(value, '1.0-2');
    }
    private fillInstallmentsOnCardObject() {
        if (this.cardsCount.length == 1) {
            return;
        }

        this.paymentService.getCards()[this.cardIndex - 1].installments = this.installmentModelValue;
    }
    private fillAmountOnCardObject() {
        if (this.cardsCount.length == 1) {
            return;
        }

        if (this.cardIndex === 1) {
            this.paymentService.getCards()[this.cardIndex - 1].amount = this.amountModelValue;
        } else {
            this.paymentService.getCards()[this.cardIndex - 1].amount = this.amountDifference;
        }
    }
    private triggerFilledIfFilled() {
        if (this.cardFormFilled) {
            this.onFilled(this.cardIndex);
        }
    }
    private sanitizeAmountValue(amount) {
        if (amount == "" || isNaN(amount)) {
            amount = 1;
        }

        let value = parseFloat(amount);
        if (value < 1) {
            value = 1;
        }

        let minimumDifference = this.total - 1;
        if (value > minimumDifference) {
            value = minimumDifference;
        }

        return value;
    }
    private normalizeInstallments(installments: Array<InstallmentModel>): Array<InstallmentModel> {
        if (!this.paymentMethod.isVoucher()) {
            return installments;
        }

        return installments.filter((installment) => installment.number === 1);
    }

    private registerInstallmentsForMultipleCards(installment, afterCallback?: () => void) {
        const installmentsNumber = parseInt(installment, 0);
        this.installmentModelValue = installmentsNumber;

        if (this.cardIndex === 1) {
            const cardInstallmentsElements = document.querySelectorAll('.card-installments');

            this.http.useAuth()
                .put('/checkout/payment/resume', {
                    'payment_method_id': this.paymentMethod.id,
                    'installments': installmentsNumber
            })
            .subscribe(res => {
                this.installmentModelValue = installment;
                this.paymentService.setInstallments(installmentsNumber);
                this.resumeUpdaterService.refresh().subscribe();

                this.loading = false;

                if (cardInstallmentsElements.length >= 2) {
                    const secondCardInstallmentsElement = cardInstallmentsElements[1] as HTMLInputElement;
                    secondCardInstallmentsElement.value = installmentsNumber.toString();

                    const changeEvent = new Event('change');
                    secondCardInstallmentsElement.dispatchEvent(changeEvent);
                }

                if (afterCallback) {
                    afterCallback();
                }
            });
        }
    }

    private registerInstallmentsForSingleCard(installment, afterCallback?: () => void) {
        const installmentsNumber = parseInt(installment, 0);
        this.loading = true;

        this.http.useAuth()
            .put('/checkout/payment/resume', {
                'payment_method_id': this.paymentMethod.id,
                'installments': installmentsNumber
        })
        .subscribe(res => {
            const totalReal = res.json().data.total;

            const installmentAmount = totalReal / installmentsNumber;

            this.installments = this.installments.map(i =>
                i.number === installmentsNumber
                    ? { ...i, amount: installmentAmount}
                    : i
            );

            this.installmentModelValue = installment;
            this.paymentService.setInstallments(installmentsNumber);
            this.resumeUpdaterService.refresh().subscribe();

            this.loading = false;

            if (afterCallback) {
                afterCallback();
            }
        });
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src727013012/src/src/app/payment/payment/option/card/option/payment.payment.option.card.option.component.ts